import AssistantBook from './AssistantBook';
import AssistantCancel from './AssistantCancel';
import AssistantConfirm from './AssistantConfirm';
import AssistantHome from './AssistantHome';
import AssistantMemberSessions from './AssistantMemberSessions';
import AssistantReschedule from './AssistantReschedule';

// MEN-5598: scheduling assistants act for a member without a Mento account.
// These pages use only the assistant session, never the member's.
export const schedulingAssistantRoutes = [
  { element: <AssistantHome />, path: '/assistant' },
  { element: <AssistantConfirm />, path: '/assistant/confirm' },
  {
    element: <AssistantMemberSessions />,
    path: '/assistant/members/:memberId',
  },
  {
    element: <AssistantBook />,
    path: '/assistant/members/:memberId/book/:coachPersonId',
  },
  {
    element: <AssistantReschedule />,
    path: '/assistant/members/:memberId/appointments/:appointmentId/reschedule',
  },
  {
    element: <AssistantCancel />,
    path: '/assistant/members/:memberId/appointments/:appointmentId/cancel',
  },
];
